/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water boils at about 100 °C at 760 mmHg, but near 34 °C at 40 mmHg.`)
};

const es_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El agua hierve a unos 100 °C a 760 mmHg, pero cerca de 34 °C a 40 mmHg.`)
};

const de_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasser siedet bei 760 mmHg bei etwa 100 °C, bei 40 mmHg jedoch schon bei etwa 34 °C.`)
};

const nl_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water kookt bij ongeveer 100 °C bij 760 mmHg, maar bij ongeveer 34 °C bij 40 mmHg.`)
};

const fr_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'eau bout vers 100 °C à 760 mmHg, mais vers 34 °C à 40 mmHg.`)
};

const it_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'acqua bolle a circa 100 °C a 760 mmHg, ma vicino a 34 °C a 40 mmHg.`)
};

const pt_br2_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A água ferve a cerca de 100 °C a 760 mmHg, mas perto de 34 °C a 40 mmHg.`)
};

const pt_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A água ferve a cerca de 100 °C a 760 mmHg, mas perto dos 34 °C a 40 mmHg.`)
};

const ja_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水は760 mmHgで約100°Cで沸騰しますが、40 mmHgでは約34°Cで沸騰します。`)
};

const zh_bp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水在 760 mmHg 下约 100 °C 沸腾，但在 40 mmHg 下约 34 °C 即可沸腾。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_ex1", locale)
	if (locale === "en") return en_bp_ex1(inputs)
	if (locale === "es") return es_bp_ex1(inputs)
	if (locale === "de") return de_bp_ex1(inputs)
	if (locale === "nl") return nl_bp_ex1(inputs)
	if (locale === "fr") return fr_bp_ex1(inputs)
	if (locale === "it") return it_bp_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_bp_ex1(inputs)
	if (locale === "pt") return pt_bp_ex1(inputs)
	if (locale === "ja") return ja_bp_ex1(inputs)
	return zh_bp_ex1(inputs)
};